import React from "react";
import { Container, Image, Row, Col } from "react-bootstrap";
import TopNavBar from "../Components/TopNavBar";
import ContentBlock from "../Components/ContentBlock";



class EsProjektas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'ES projektas',
        }
    }

    render() {

        const myStyle = {
            backgroundImage: "url(/main-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        return (
            <Container fluid style={myStyle}>
                <TopNavBar activeRoute={7} />
                <Container>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlock>
                        <Row>
                            <Col xs={4} md={4}>
                                </Col>
                            <Col xs={3} md={3}>
                                <Image src='/ESProjLogo.png' mx={'auto'} d={'block'} width={300} />
                            </Col>
                        </Row>
                        <div className="es-projektas-block">
                            <h4>Sukūrėme naują elektroninę prekybos platformą!</h4>
                            <p className="es-projektas-p">
                                Viešosios įstaigos Arvydo švietimo ir mokymo centras  mato didelį poreikį kursams apie įvairias pasaulio virtuves, patiekalus. Globalėjant pasauliui Lietuvos žmonės daug keliauja ir skanauja įvairių šalių patiekalų ir taip gimsta noras visus skaniausius patiekalus išmokti pagaminti patiems.  Taip pat pastebimas poreikis prasmingam laisvalaikio praleidimui, kai gaminant maistą, žmonės bendrauja, suranda bendrų sąlyčio taškų. Įmonė atliepdama augančiam rinkos poreikiui ES projekto pagalba sukūrė naują elektroninės prekybos sistemą, kuri bus skirta pristatyti ir parduoti kulinarijos kursus.
                            </p>
                            <p className="es-projektas-p">
                                Projektas finansuojamas Europos regioninės plėtros fondo lėšomis. Projektas pradėtas 2022 metais ir baigtas 2023 m. kovo mėn.
                            </p>
                            <p className="es-projektas-p">
                                Projekto vertė 37 631,00 EUR, Europos regioninės plėtros fondo parama siekia 28 223,25 EUR.
                            </p>
                            <p className="es-projektas-p">
                                Projektas įgyvendinamas pagal 2014–2020 metų Europos Sąjungos fondų investicijų veiksmų programos 13 prioriteto „Veiksmų, skirtų COVID-19 pandemijos sukeltai krizei įveikti, skatinimas ir pasirengimas aplinką tausojančiam, skaitmeniniam ir tvariam ekonomikos atgaivinimui“ priemonės Nr. 13.1.1-LVPA-K-860 „E. komercijos modelis COVID-19“ projektų finansavimo sąlygų aprašą.
                            </p>
                            <p>
                                Kontaktai pasiteiravimui
                            </p>
                            <p>
                                Tel.: 8 656 26 937, El. paštas: info@virtuvesklubas.lt
                            </p>
                        </div>
                    </ContentBlock>
                </Container>
            </Container>
        );
    }
}

export default EsProjektas;